import { aktformatStorageKey } from '../../akt/SokAkt';
import {
  activeBostadsvarderingStorageKey,
  viewStorageKey,
} from '../../bostadsvardering/components/VarderingPage';
import { ForetagStorageType } from '../../foretag/components/ForetagSearchForm';
import { fastigheterStorageKey } from '../../forteckningar/Forteckningar';
import { mapDataStorageKey, mapStateStorageKey } from '../../kartstod/InitMap';
import { tokenStoreKey } from './fetchWrapper';

interface StorageItem<T> {
  expirationDate: Date;
  value: T;
}

export const saveToStorage = <T>(key: string, data: T) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const storageItem: StorageItem<T> = {
    expirationDate: tomorrow,
    value: data,
  };

  window.localStorage.setItem(key, JSON.stringify(storageItem));
};

export const getFromStorage = <T>(key: string): T => {
  const item = JSON.parse(window.localStorage.getItem(key)) as StorageItem<T>;
  if (item?.expirationDate) {
    if (new Date(item.expirationDate) < new Date()) {
      removeStorageKey(key);
      return;
    }
    return item.value;
  }
};

export const removeStorageKey = (key: string): void => removeStorageKeys([key]);

export const removeStorageKeys = (keys: string[]): void =>
  keys.forEach((key) => {
    window.localStorage.removeItem(key);
  });

export const storageKeys = [
  tokenStoreKey,
  mapStateStorageKey,
  aktformatStorageKey,
  viewStorageKey,
  activeBostadsvarderingStorageKey,
  fastigheterStorageKey,
  mapDataStorageKey,
  ...Object.values(ForetagStorageType),
];
